/** @format */

const NotificationItem = ({ notification }) => {
  const { notification_id, user_name, user_image, activity_time } =
    notification;

  return (
    <div
      key={notification_id}
      className="notification flex items-center pb-3 border-b border-gray-300 mb-3"
    >
      <div className="profile rounded-full flex items-center justify-center flex-shrink-0 h-10 w-10">
        <img
          src={user_image}
          className="rounded-full h-full w-full object-cover"
          alt="Profile"
        />
      </div>
      <div className="content ml-4">
        <p className="text-base">
          <span className="text-dark">{user_name}</span>{" "}
          <span className="text-gray-500 text-sm">{notification.activity}</span>
        </p>
        <p className="text-gray-500 text-sm">{activity_time}</p>
      </div>
    </div>
  );
};


export default NotificationItem